<template>
  <div>
    <!-- <el-button
      icon="el-icon-tickets"
      @click="importFromSpec()"
      v-if="!getAuthShow()"
      :loading="importSpecLoading"
      >{{ labelText("Import From Spec") }}</el-button
    > -->
    <el-button type="primary" @click="saveHandle()" :loading="saveLoading" >{{
      labelText("Save")
    }}</el-button>

    <el-button type="warning" @click="verifyEnglishHandle()" v-if="!getAuthShow() && getAuthChinaShow()">{{ labelText("Verify") }}</el-button>
    <el-button type="warning" @click="verifyChinaHandle()" v-if="getCnLanguage()">{{ $t("action.china_verify") }}</el-button>

    <el-button
      type="primary"
      :loading="previewPdfLoading"
      @click="previewHandle()"
      >{{ labelText("Preview PDF") }}</el-button
    >
    <el-button @click="goBack()">{{ labelText("Back Home") }}</el-button>
  </div>
</template>
<script>
// import * as StructConvertUtils from "../../spec/config/structConvertUtils";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
import { apiServer } from "@/network/modules/detail-api";
import { EventBus } from "@/views/NEW/module/spec/config/eventBus";
import base from "@/common/base.js";
export default {
  props: {
    isPrintSignature: Boolean,
    tabId: {
      type: [String, Number],
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  computed: {
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    optionButtonFlag() {
      return this.pageStatus === "Detail";
    },
    labelText() {
      return (label) => {
        let key = "action." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
  },
  inject: [
    "getModulesDataMethod", 
    "importSpecDataMethod",
    "getCurrentDataMethod",
    "getNotesConfigMethod",
    "getCustomNotesMethod",
    "getVersionInfoMethod",
    "getShelflifeNumberMethod"
  ],
  data() {
    return {
      language: "EN",
      saveLoading: false,
      verifyLoading: false,
      previewPdfLoading: false,
      importSpecLoading: false,
      isChinaVerify: false,
    };
  },
  methods: {
    getAuthShow(){
      return base.getAuthShow();
    },
    getAuthChinaShow(){
      const roleId = JSON.parse(localStorage.getItem("specUserInfo")).roleId;
      if(roleId == 5){
        return false;
      }
      return true;
    },
    getCnLanguage(){
      let language = this.getCurrentDataMethod().language || 'en';
      let flag = language.toLowerCase() == 'cn' || language.toLowerCase() == 'zh';
      return flag && !this.getAuthChinaShow();
    },
    importFromSpec() {
      console.info("[DEBUG] importFromSpec method called")
      this.importSpecLoading = true;
      setTimeout(() => {
        this.importSpecLoading = false;
      }, 3000);
      
      console.info("[DEBUG] Calling importSpecDataMethod")
      console.info("[DEBUG] importSpecDataMethod exists:", typeof this.importSpecDataMethod)
      
      this.importSpecDataMethod((data) => {
        console.info("[DEBUG] importSpecData response:",data)
        
        if(data==null){
          console.info("[DEBUG] Response data is null")
          this.$message({
            message: this.$t("confirm.import_spec_fail"),
            type: "error",
          });
          return;
        }
        this.importSpecLoading = false;
      })
      // .then(()=>{
      //   this.importSpecLoading = false;
      // });
    },
    // 保存按钮点击
    saveHandle() {
      let type = this.$route.query.type;

      this.saveLoading = true;
      this.$emit("save", (res) => {
        // Save 的时候没有获取到已经更新的文本值
        let params = this.getSaveData(res);
        params.lot = res.base_info.lot;
        params.manufacutureData = res.base_info.manufacuture_date;
        params.expirationDate = res.base_info.expiration_date;

        // 使用inject获取数据，替代localStorage
        const currentData = this.getCurrentDataMethod();
        // 这些字段已经在getSaveData中设置，只需要覆盖特定的字段
        params.chinaLot = currentData.chinaLot || "";
        if(currentData.verified){
          params.verified = 1;
        }else{
          params.verified = 0;
        }
        const isCopy = this.$route.query.isCopy === "false" ? false : !!this.$route.query.isCopy;
        console.info("isCopy1:",isCopy)
        if(isCopy){
          params.verified = 0;
        }

        console.info("saveHandle-最终params:", params);
        console.info("saveHandle-关键字段:", {
          qty: params.qty,
          shipmentDate: params.shipmentDate,
          shippingMethod: params.shippingMethod,
          tyNumber: params.tyNumber,
          chinaLot: params.chinaLot
        });
        setTimeout(() => {
          this.saveLoading = false;
        }, 5000);
        apiServer.getDataByType(type, "saveOrUpdate", params, data => {
          console.info("saveOrUpdate:",data)
          this.saveLoading = false;
          if (this.pageStatus === "Add") {
            // 如果当前是Add状态，保存后切换到Edit状态
            EventBus.$emit("pageStatusChange", "Edit"); // 通知其他组件状态变化
            let language = currentData.language || 'en';
            this.$router.replace({
              path: "detail",
              query: {
                id: data.id,
                type: "coa",
                isCopy: "false",
                language: language,
              },
            });
          }

          // 更新当前数据
          const updatedCurrentData = this.getCurrentDataMethod();
          updatedCurrentData.verifiedTime = data.updateTime;
          console.info('verifiedTime:',data.updateTime)
          
          this.$message({
            message: this.$t("confirm.save_success"),
            type: "success",
          });
          
          // 清空自定义notes
          this.getCustomNotesMethod().length = 0;
          this.saveLoading = false;
        });
      });
    },
    verifyHandle() {
      // 检查当前记录是否已经有 verified 版本
      const currentData = this.getCurrentDataMethod();
      this.$confirm(this.$t("confirm.verify_tips"), this.$t("confirm.tips"), {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.$emit("save", (data) => {
          // 检查 revisionData
          console.info('data.rev.revision===:',data.rev.revision)
          let revision = data.rev.revision[data.rev.revision.length - 1];
          console.info("revision:", revision);
          
          // 使用inject获取数据，替代localStorage
          revision.requestedBy = currentData.loginUserName || "";
          
          let userInfo = JSON.parse(localStorage.getItem("specUserInfo"));
          revision.isComplete = true;
          revision.approvedBy = userInfo.nickname;

          data.rev.revision[data.rev.revision.length - 1] = revision;
          let saveData = this.getSaveData(data);
          if(this.isChinaVerify){
            saveData.verified = 0;
            saveData.isChinaVerified = 1;
            saveData.chinaVerified = 1;
            saveData.chinaVerifiedTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
            saveData.chinaVerifiedName = userInfo.nickname;
          }else{
            saveData.isChinaVerified = 0;
            saveData.verified = 1;
            revision.verifyName = userInfo.nickname;
            revision.verifyTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
          }

          console.info("data:", saveData);
          this.verifyLoading = true;
          this.verifyNewCoa(saveData);
        });
      });
    },
    verifyNewCoa(saveData){
      saveData.lot = JSON.parse(saveData.jsonValue).base_info.lot;
      apiServer.getDataByType("coa","verify",saveData,data=>{
        console.info('verifyNewCoa:',data)
        if(data.id){
          this.$message({
            message: this.$t("confirm.verify_success"),
            type: "success",
          });
          window.location.reload();
        }
        this.verifyLoading = false;
      })
    },
    verifyEnglishHandle(){
      this.isChinaVerify = false;
      console.info("verifyEnglishHandle")
      this.verifyHandle(this.isChinaVerify);
    },
    verifyChinaHandle(){
      this.isChinaVerify = true;
      console.info("verifyChinaHandle")
      this.verifyHandle(this.isChinaVerify);
    },
    // 获取保存数据
    getSaveData(data) {
      let paramsId = "";
      const isCopy =
        this.$route.query.isCopy === "false"
          ? false
          : !!this.$route.query.isCopy;

      if (this.$route.query.id && !isCopy) {
        paramsId = this.$route.query.id;
      }

      console.info('data555555:',data.other_notes.notes instanceof Array)
      
      // 使用inject获取数据，替代localStorage
      const currentData = this.getCurrentDataMethod();
      const notesConfig = this.getNotesConfigMethod();
      
      // 修复：直接使用data.other_notes.notes，不再重复追加customNotes
      // 因为在saveValueHandle中已经处理过了
      let custome_note = Array.isArray(data.other_notes.notes) ? data.other_notes.notes : [];
      
      console.info('修复后-custome_note数量:', custome_note.length);
      console.info('修复后-custome_note内容:', custome_note);
      
      // 设置coa的Notes打印配置
      let notes = {
        "note1": notesConfig.additionalNotes.note1 || false,
        "note2": notesConfig.additionalNotes.note2 || false,
        "note3": notesConfig.additionalNotes.note3 || false,
        "custom": custome_note,
        "is_show_note": notesConfig.additionalNotes.cnNote1
      }
      data.notes = notes;
      console.info("修复后-最终notes==>", notes)

      // 生产日期和有效日期 英文版使用YYYY-MM格式，中文使用YYYY-MM-DD
      let manufacuture_date_day = '01';
      let expiration_date_day = '01';
      let language = currentData.language || 'en';
      
      // 安全地处理日期字符串，添加空值检查
      const safeSubstring = (str, start, end) => {
        if (!str || typeof str !== 'string') return '';
        return str.length >= (end || start) ? str.substring(start, end) : str;
      };
      
      if(language.toLocaleLowerCase() == 'en'){
        // 安全地截取日期字符串
        if (data.base_info.expiration_date && typeof data.base_info.expiration_date === 'string') {
          data.base_info.expiration_date = safeSubstring(data.base_info.expiration_date, 0, 7);
        }
        if (data.base_info.manufacuture_date && typeof data.base_info.manufacuture_date === 'string') {
          data.base_info.manufacuture_date = safeSubstring(data.base_info.manufacuture_date, 0, 7);
        }
      }else{
        // 中文版本的日期处理
        if(data.base_info.manufacuture_date && 
           typeof data.base_info.manufacuture_date === 'string' && 
           data.base_info.manufacuture_date.length >= 10){
          let tmp_day = safeSubstring(data.base_info.manufacuture_date, 8, 10);
          if (tmp_day) {
            manufacuture_date_day = tmp_day;
            expiration_date_day = tmp_day;
          }
        }else if(data.base_info.expiration_date && 
                 typeof data.base_info.expiration_date === 'string' && 
                 data.base_info.expiration_date.length >= 10){
          let tmp_day = safeSubstring(data.base_info.expiration_date, 8, 10);
          if (tmp_day) {
            manufacuture_date_day = tmp_day;
            expiration_date_day = tmp_day;
          }
        }
        
        // 安全地构建日期字符串
        if (data.base_info.manufacuture_date && typeof data.base_info.manufacuture_date === 'string') {
          data.base_info.manufacuture_date = safeSubstring(data.base_info.manufacuture_date, 0, 7) + "-" + manufacuture_date_day;
        }
        if (data.base_info.expiration_date && typeof data.base_info.expiration_date === 'string') {
          data.base_info.expiration_date = safeSubstring(data.base_info.expiration_date, 0, 7) + "-" + expiration_date_day;
        }
      }

      let verified = currentData.verified || false;
      
      // 从versionInfo或data中获取正确的revNumber值
      const versionInfo = this.getVersionInfoMethod();
      let revNumber = data.revNumber || currentData.revNumber || 1;
      if (versionInfo && versionInfo.revNumber) {
        revNumber = versionInfo.revNumber;
      }
      
      
      let saveData = { 
        id: paramsId,
        itemCode: data.base_info.item_code,
        productType: data.base_info.product_type,
        productName: data.base_info.product_name,
        productDescription: data.base_info.product_description,
        physicalProperties: data.base_info.physical_properties,
        countryOfOrigin: data.general_specification.country_of_origin,
        botanicalName: data.general_specification.botanical_name.toString(),
        poNumber: data.base_info.po_number,
        shelflifeNumber: this.getShelflifeNumberMethod(), // 从 inject 获取 shelflifeNumber
        verifiedListUser: "",
        verifiedList: 0,
        revNumber: revNumber,
        verified: verified,
        verified_time: "",
        rev_number: revNumber,
        jsonValue: JSON.stringify(data),
        // 添加这些必要的字段
        qty: currentData.qty || 0,
        shipmentDate: currentData.shipmentDate || "",
        shippingMethod: currentData.shippingMethod || "",
        tyNumber: currentData.tyNumber || "",
        chinaLot: currentData.chinaLot || "",
      };
      
      // 保护敏感字段：在更新时保持从API中读取的原始值
      if (paramsId && !isCopy) {
        // 从currentData中获取这些字段的原始值，确保不被修改
        const roleId = JSON.parse(localStorage.getItem("specUserInfo")).roleId;
        let isChinaVerified = false;
        if(roleId == 5){
          isChinaVerified = true;
        }
        console.info("isChinaVerified:",isChinaVerified)
        if (currentData.verifiedTime && !isChinaVerified) {
          saveData.verifiedTime = currentData.verifiedTime;
        }
        if (currentData.verifiedName && !isChinaVerified) {
          saveData.verifiedName = currentData.verifiedName;
        }
        if (currentData.createName) {
          saveData.createName = currentData.createName;
        }
        if (currentData.updateName) {
          saveData.updateName = currentData.updateName;
        }
        if (currentData.createTime) {
          saveData.createTime = currentData.createTime;
        }
        if (currentData.updateTime) {
          saveData.updateTime = currentData.updateTime;
        }
        
        console.info('更新操作-保护的敏感字段:', {
          verifiedTime: saveData.verifiedTime,
          verifiedName: saveData.verifiedName,
          createName: saveData.createName,
          updateName: saveData.updateName,
          createTime: saveData.createTime,
          updateTime: saveData.updateTime
        });
      }
      
      console.info('getSaveData-保存的字段:', {
        qty: saveData.qty,
        shipmentDate: saveData.shipmentDate,
        shippingMethod: saveData.shippingMethod,
        tyNumber: saveData.tyNumber
      });
      
      return saveData;
    },
    // 预览打印
    previewHandle() {
      this.$emit("save", (res) => {
        let saveData = this.getSaveData(res);
        // 判断过期日期是否是只有年和月
   
        let previewPdf = this.pageStatus !== "Detail"; // 详情状态下不能预览，否则可以

        //预览后端需要的字段为 json_value
        // 处理 notes 为数组
        saveData.json_value = saveData.jsonValue;
        console.info('saveData:', saveData)
        
        // 使用inject获取数据，替代localStorage
        const currentData = this.getCurrentDataMethod();
        let verifiedTime = currentData.verifiedTime;
        console.info(">>>get data.verifiedTime:", saveData.verified_time)
        
        if (verifiedTime && verifiedTime !== 'null' && verifiedTime !== null) {
          let date = new Date(verifiedTime);
          saveData.verified_time = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        } else {
          let date = new Date();
          saveData.verified_time = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        }
        
        let verified = currentData.verified || false;
        if (!verified) {
          saveData.verified_time = "";
        }
        saveData.verifiedTime = saveData.verified_time;
        delete saveData.jsonValue;

        let languageType = "US";
        let language = currentData.language || 'en';
        if (language == "cn" || language == "zh") {
          languageType = "China";
          let cnJsonValue = JSON.parse(saveData.json_value);
          cnJsonValue.base_info.print_title = "";
          saveData.json_value = JSON.stringify(cnJsonValue);
        }
        
        let lot = JSON.parse(saveData.json_value).base_info.lot;
        let fileName = saveData.productName + "_" + lot;
        fileName = fileName.replace(/[%<>:"/\\|?*]/g, "");

        if (previewPdf) {
          if (languageType == "China") {
            fileName = "(Preview 中文 CoA)" + fileName;
          } else {
            fileName = "(Preview CoA)" + fileName;
          }
        } else {
          if (languageType == "China") {
            fileName = "(中文 CoA)" + fileName;
          } else {
            fileName = "(CoA)" + fileName;
          }
        }
        
        let params = {
          print_type: "coa",
          language: languageType,
          data: saveData,
          cutomer_signature: this.isPrintSignature,
          preview_pdf: previewPdf,
          file_name: fileName,
          response_type: "text",
          verifed_signature: true
        };

        this.previewServer(params);
      });
    },
    previewServer(params) {
      this.previewPdfLoading = true;
      this.$axios
        .post("https://spec.dracoherbs.com/flask/generate_spec", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.previewPdfLoading = false;
          let fileUrl =
            "https://spec.dracoherbs.com/download/" + response.data.file_name;
          setTimeout(function () {
            window.open(fileUrl);
          }, 200);
        })
        .catch((error) => {
          this.previewPdfLoading = false;
          console.error(error);
        });
    },
    goBack() {
      window.history.back();
    },
  },
  created() {
    // 绑定事件处理器到实例，便于销毁时移除
    this.setupSpecInfoHandler = (itemCode) => {
      // console.info("[DEBUG] setupSpecInfoHandler received itemCode:", itemCode)
      // Import For Spec功能应该在任何tab都能工作，移除tab限制
      const currentData = this.getCurrentDataMethod();
      // console.info("[DEBUG] currentData before setting itemCode:", currentData)
      currentData.itemCode = itemCode;
      // console.info("[DEBUG] calling importFromSpec")
      this.importFromSpec();
    };
    
    EventBus.$on("setupSpecInfoByItemCode", this.setupSpecInfoHandler);
  },
  beforeDestroy() {
    console.info("beforeDestroy")
    // 组件销毁时移除事件监听器，避免内存泄漏
    if (this.setupSpecInfoHandler) {
      EventBus.$off("setupSpecInfoByItemCode", this.setupSpecInfoHandler);
    }
  },
};
</script>